import React from "react";
import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 pc-grid-bg">
      <div className="pc-card p-10 max-w-md text-center">
        <h1 className="text-2xl font-bold text-white mb-2" style={{fontFamily:'Outfit'}}>Checkout canceled</h1>
        <p className="text-slate-400 mb-6">No worries — you can start your trial anytime.</p>
        <Link to="/pricing" className="bg-gradient-to-r from-blue-500 to-blue-700 text-white px-5 py-2.5 rounded-lg font-semibold inline-block">Back to pricing</Link>
      </div>
    </div>
  );
}
